<template>
  <div class="yxtbiz-teacher-subscribe-manage radius6 hline">
    <!-- 讲师预约基本信息-->
    <div v-loading="baseLoading" class="p24 flex space-beetween">
      <div class="base-left">
        <div class="pb16">
          <span class="color-gray-7 d-in-block lh22 mr">{{`${$t('pc_biz_jq_lbl_taskName' /* 任务名称 */)}：`}}</span>
          <span class="color-gray-10">{{ baseInfo.targetName || '--' }}</span>
        </div>
        <div class="pb16">
          <span class="color-gray-7 d-in-block lh22">{{`${$t('pc_biz_shoptour_planstatus' /* 任务状态 */)}：`}}</span>
          <span class="color-gray-10">{{ getTargetStatus(baseInfo.targetStatus) }}</span>
        </div>
        <div class="pb16">
          <span class="color-gray-7 d-in-block lh22">{{`${$t('pc_biz_te_subscribe_time' /* 预约时段 */)}：`}}</span>
          <span class="color-gray-10">{{ `${baseInfo.apptStartDate || '--'} ~ ${baseInfo.apptEndDate || '--'}` }}</span>
        </div>
        <div class="vertical-center">
          <span class="color-gray-7 d-in-block lh22">{{`${$t('pc_biz_rich_lbl_link' /* 链接 */)}：`}}</span>
          <span v-if="!baseInfo.targetUrl" >--</span>
          <template v-else>
            <yxt-tooltip
              class="item"
              effect="dark"
              :open-filter="true"
              :content="baseInfo.targetUrl"
              placement="top">
              <span class="ellipsis mr8">{{baseInfo.targetUrl}}</span>
            </yxt-tooltip>
            <yxt-svg
              :icon-class="'o2o-enroll-copy'"
              width="16px"
              height="16px"
              class="hand flex-shrink-0"
              :remote-url="`${$staticBaseUrl}ufd/55a3e0/o2o/pc/svg`"
              @click.native="copyUrl"
            ></yxt-svg>
          </template>
        </div>
      </div>
      <div class="base-right bg-fbfbfb">
        <div class="base-right__wrap">
          <div class="pb16 vertical-center">
            <span class="color-gray-10">{{ $t('pc_biz_te_pass_number' /* 已通过人数 */) }}</span>
            <yxt-tooltip
              :content="$t('pc_biz_te_passed_number' /* 已成为正式老师的人数 */)"
              placement="top"
            >
              <yxt-svg width="16px" height="16px" class="ml4 color-gray-6" icon-class="question-cirlce-o"/>
            </yxt-tooltip>
            <span v-if="isFulled" class="pl6 full">{{ $t('pc_biz_te_pass_number_fulled' /* 满员 */) }}</span>
            <span v-else class="pl6 notfull color-red-6">{{ $t('pc_biz_te_pass_number_notfulled' /* 未满员 */) }}</span>
          </div>
          <div class="pb16">
            <span class="primary-font-style color-gray-10">{{ baseInfo.approvedOfficial }}</span>
            <span class="color-gray-7">/</span>
            <span class="color-gray-7">{{ baseInfo.maxAppt }}</span>
          </div>
          <div v-if="!isFulled" class="notfull-status">
            <div>
              <span>{{ `${ $t('pc_biz_te_status_passed_backup' /*已通过(替补)*/) }(${ baseInfo.approvedBackUp })；` }}</span>
              <span>{{ `${ $t('pc_biz_te_status_pending' /*待处理*/) }(${ baseInfo.pending })；` }}</span>
              <span>{{ `${ $t('pc_biz_te_status_rejected' /*已拒绝*/) }(${ baseInfo.rejected })；` }}</span>
              <span>{{ `${ $t('pc_biz_te_status_checking' /*审核中*/) }(${ baseInfo.auditing })；` }}</span>
            </div>
            <div>
              <span>{{ `${ $t('pc_biz_te_status_notpassed' /*未通过*/) }(${ baseInfo.notApproved })；` }}</span>
              <span>{{ `${ $t('pc_biz_enroll_lbl_disqualification' /*取消资格*/) }(${ baseInfo.canceled })；` }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w100p cross-line"></div>
    <!-- 讲师预约表格 -->
    <div v-loading="tableLoading" class="bg-white pv24 ph24">
      <div class="btn_common_display yxtbiz-teacher-subscribe__filter">
        <div class="btn_common_display_item mb16">
           <!-- 催促处理 -->
            <yxt-button v-if="baseInfo.enableUrg" type="primary" size="medium" @click="debounceUrge">{{ $t('pc_biz_te_urge') }}</yxt-button>
            <yxt-tooltip v-else class="item" :content="$t('预约已结束').d('预约已结束')" placement="top">
              <span style="display: inline-block; height: 32px;">
                <yxt-button @click="debounceUrge" disabled>{{ $t('pc_biz_te_urge') }}</yxt-button>
              </span>
            </yxt-tooltip>
            <!--添加名额-->
            <!-- <yxt-button plain size="large" @click="addTe">{{ $t('pc_biz_te_add_place') }}</yxt-button> -->
        </div>
        <div class="btn_common_display_item mb16">
          <yxt-select
            v-model="teSearch.apptUserStatus"
            class="mr12 w144 h32 lh32"
            clearable
            :placeholder="$t('pc_biz_shoptour_status').d('状态')"
            @change="refresh"
          >
            <yxt-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </yxt-option>
          </yxt-select>
          <yxt-input
            v-model="teSearch.keyword"
            :placeholder="$t('pc_biz_enroll_tip_search').d('请输入名称搜索')"
            searchable
            clearable
            maxlength="50"
            style="width: 240px;"
            @search="refresh"
            @clear="refresh"
          ></yxt-input>
        </div>
      </div>
      <yxt-table
        :ref="refTable"
        class="yxtbiz-teacher-subscribe__table"
        :data="teaList"
      >
        <!-- 讲师姓名 -->
        <yxt-table-column
          :label="$t('pc_biz_te_lbl_teachernameaccount')"
          :show-overflow-tooltip="false"
          prop="teName"
          align="left"
        >
          <template slot-scope="scope">
            <div class="yxtbiz-teacher-flex-center">
              <yxt-tooltip effect="dark" placement="top" :open-filter="true">
                <div slot="content">
                  <span><yxtbiz-user-name :name="scope.row.teName" /></span>
                </div>
                <div class="ellipsis nowrap">
                  <span><yxtbiz-user-name :name="scope.row.teName" /></span>
                </div>
              </yxt-tooltip>
            </div>
          </template>
        </yxt-table-column>
        <!-- 级别 -->
        <yxt-table-column show-overflow-tooltip
          :label="$t('pc_biz_te_lbl_level')"
          prop="levelName"
          align="left"
        >
          <template slot-scope="scope">
            {{scope.row.levelName || '--'}}
          </template>
        </yxt-table-column>
        <!-- 部门 -->
        <yxt-table-column
          show-overflow-tooltip
          popover-html
          :label="$t('pc_biz_te_lbl_department')"
          prop="deptName"
          align="left"
        >
          <template slot-scope="scope">
            <yxtbiz-dept-name :name="scope.row.deptName || '--'" />
          </template></yxt-table-column>
        <!-- 岗位 -->
        <yxt-table-column
          prop="position"
          :label="$t('biz_udp_position')"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span><yxtbiz-position-name :name="scope.row.position || '--'" /></span>
          </template>
        </yxt-table-column>
        <!-- 加入方式 -->
        <yxt-table-column
          prop="joinType"
          :label="$t('pc_biz_te_jointype').d('加入方式')"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ getJoinType(scope.row.joinType) }}</span>
          </template>
        </yxt-table-column>
        <!-- 预约状态 -->
        <yxt-table-column
          :label="$t('pc_biz_te_subscribe_status').d('预约状态')"
          width="150"
          prop="apptUserStatus"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <yxt-tag is-status-tag :type="getStatusColor(scope.row.apptUserStatus)">
              <!--利用了数组下标？？？-->
              <span>{{ statusOptions[scope.row.apptUserStatus].label }}</span>
              <yxt-popover
                trigger="hover"
                placement="top"
                class="appointment-reason"
                width="200"
                :title="scope.row.apptUserStatus === APPOINTMENT_STATUS_ENUM.UNPASS ? $t('pc_biz_lbl_unpass_reason').d('未通过原因') : $t('pc_biz_lbl_reject_reason').d('拒绝原因')"
                :content="scope.row.apptUserStatus === APPOINTMENT_STATUS_ENUM.UNPASS ? scope.row.auditDesc : scope.row.rejectedReason">
                <yxt-svg
                  slot="reference"
                  v-show="(scope.row.apptUserStatus === APPOINTMENT_STATUS_ENUM.UNPASS && scope.row.auditDesc)
                    || (scope.row.apptUserStatus === APPOINTMENT_STATUS_ENUM.REJECT && scope.row.rejectedReason)"
                  width="16px" height="16px" class="ml8 color-gray-6" icon-class="info-cirlce-o"
                />
              </yxt-popover>
            </yxt-tag>
          </template>
        </yxt-table-column>
        <!-- 操作时间 -->
        <yxt-table-column
          prop="joinTime"
          :label="$t('pc_biz_te_operate_time').d('操作时间')"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.joinTime || '--' }}</span>
          </template>
        </yxt-table-column>
        <!-- 操作 -->
        <yxt-table-column :label="$t('pc_biz_te_lbl_operation')" width="200" align="left">
          <template slot-scope="scope">
            <!-- 查看 -->
            <yxt-link
              @click="lookTea(scope.row)"
              :underline="false"
              type="primary"
              class="mr10"
            >{{ $t('pc_biz_enroll_lbl_view').d('查看') }}</yxt-link>
            <!-- 转正 -->
            <yxt-link
              v-if="scope.row.canBeOfficial"
              @click="passTea(scope.row)"
              :underline="false"
              type="primary"
              class="mr10"
            >{{ $t('pc_biz_te_btn_beofffical').d('转正') }}</yxt-link>
            <!-- 取消资格 -->
            <yxt-link
              v-if="scope.row.canCancel"
              @click="rejectTea(scope.row)"
              :underline="false"
              type="primary"
            >{{ $t('pc_biz_enroll_lbl_disqualification').d('取消资格') }}</yxt-link>
          </template>
        </yxt-table-column>
        <template slot="empty">
          <div style="line-height:normal">
            <yxt-empty :empty-text="$t('pc_biz_lbl_nodata'/*暂无数据*/)"/>
          </div>
        </template>
      </yxt-table>
      <div class="mt16 clearfix pr">
        <yxt-pagination
          class="pull-right"
          show-on-single-page
          :total="count"
          :current-page="page"
          :page-size="teSearch.limit"
          :page-sizes="[5, 10, 20, 30, 50, 100]"
          layout="total, prev, pager, next, sizes, jumper"
          @current-change="pageChange"
          @size-change="sizeChange"
        ></yxt-pagination>
      </div>
    </div>
    <!-- 添加内部讲师 -->
    <teacher-selector
      :value="selectTeacher.data"
      :visible.sync="selectTeacher.visible"
      :teacherType="0"
      :singleMode="selectTeacher.singleMode"
      :allowSelectUser="false"
      :newReq="true"
      :prepared="true"
      functionCode="te_lib"
      dataPermissionCode="lecturer_get_extent"
      selectUserPermissionCode="lecturer_get_extent"
      @submit="selectTeacher.callback" />
  </div>
</template>

<script>
import { APPOINTMENT_STATUS_ENUM } from './const';
import {
  getSubscribeBaseinfo,
  getSubscribeTeList,
  urgeTeSubscribe,
  passteSubscribe,
  rejectTeSubscribe,
  addSubscribeTeList
} from './service';
import resizeTable from '../../user-selector/mixins/resizeTable';
import UserName from 'yxt-biz-pc/packages/user-name';
import DeptName from 'yxt-biz-pc/packages/dept-name';
import { Table, TableColumn, Pagination, Link, Select, Option } from 'yxt-pc';
import TeacherSelector from './components/teacherSelector';

export default {
  name: 'YxtbizTeacherSubscribeManage',
  name_zh: '讲师预约管理',
  eventList: [
  ],
  components: {
    YxtbizUserName: UserName,
    YxtbizDeptName: DeptName,
    YxtTable: Table,
    YxtTableColumn: TableColumn,
    YxtPagination: Pagination,
    YxtLink: Link,
    YxtSelect: Select,
    YxtOption: Option,
    TeacherSelector
  },
  mixins: [resizeTable],
  props: {
    targetId: {
      type: String,
      default: '',
      desc: '任务 targetId',
      setter: 'StringSetter'
    }
  },
  computed: {
    isFulled() {
      return this.baseInfo.approvedOfficial >= this.baseInfo.maxAppt;
    }
  },
  data() {
    return {
      APPOINTMENT_STATUS_ENUM,
      timer: '',
      baseInfo: {},
      tableHeight: 0,
      refTable: 'subscribeTable',
      page: 1,
      teSearch: {
        apptUserStatus: '',
        keyword: '',
        limit: 10,
        offset: 0,
        direction: 'asc',
        targetId: ''
      },
      tableLoading: false,
      baseLoading: false,
      count: 0,
      teaList: [],
      statusOptions: [
        {
          value: 0,
          label: this.$t('pc_biz_te_status_pending') // 待处理
        },
        {
          value: 1,
          label: this.$t('pc_biz_te_status_checking') // 审核中
        },
        {
          value: 2,
          label: this.$t('pc_biz_te_status_passed_offical') // 已通过(正式)
        },
        {
          value: 3,
          label: this.$t('pc_biz_te_status_passed_backup') // 已通过(替补)
        },
        {
          value: 4,
          label: this.$t('pc_biz_te_status_notpassed') // 未通过
        },
        {
          value: 5,
          label: this.$t('pc_biz_enroll_lbl_disqualification') // 取消资格
        },
        {
          value: 6,
          label: this.$t('pc_biz_te_status_rejected') // 已拒绝
        }
      ],
      // 选择讲师抽屉
      selectTeacher: {
        data: [],
        visible: false,
        callback: () => {},
        singleMode: false
      }
    };
  },
  mounted() {
    this.getTeList();
    this.getBaseinfo();
  },
  methods: {
    getBaseinfo() {
      if (!this.targetId) return false;
      this.baseLoading = true;
      getSubscribeBaseinfo(this.targetId)
        .then(result => {
          this.baseInfo = result || {};
          this.baseLoading = false;
        }).catch(e => {
          this.baseLoading = false;
        });
    },
    // 列表数据
    getTeList() {
      this.tableLoading = true;
      const searchBody = { ...this.teSearch };
      searchBody.targetId = this.targetId;
      searchBody.keyword = searchBody.keyword.trim();
      searchBody.apptUserStatus = searchBody.apptUserStatus === '' ? -1 : searchBody.apptUserStatus;
      searchBody.offset = (this.page - 1) * searchBody.limit;
      let teApi = getSubscribeTeList;
      teApi(searchBody)
        .then(result => {
          this.teaList = result.datas;
          this.count = result.paging.count;
          this.tableLoading = false;
        }).catch(e => {
          this.tableLoading = false;
          console.log(e);
        });
    },
    refresh() {
      this.page = 1;
      this.teSearch.offset = 0;
      this.getTeList();
    },
    sizeChange(size) {
      this.teSearch.limit = size;
      this.getTeList(true);
    },
    pageChange(page) {
      this.page = page;
      this.teSearch.offset = (page - 1) * this.teSearch.limit;
      this.getTeList();
    },
    debounce(func, delay = 1000) {
      return () => {
        let args = arguments;
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    // 催促处理
    urge() {
      if (!this.targetId) return false;
      urgeTeSubscribe(this.targetId)
        .then(result => {
          this.$notify({
            title: this.$t('pc_biz_te_msg_urge_success').d('催促成功'),
            message: this.$t('pc_biz_te_msg_has_urged').d('已催促未处理的讲师'),
            type: 'success'
          });
        }).catch(e => {
          this.handleError(e);
        });
    },
    debounceUrge() {
      this.debounce(this.urge)();
    },
    // 查看
    lookTea(val) {
      if (!val.teId) return false;
      let href = window.location.origin + `/te/#/tedetail?id=${val.teId}`;
      window.open(href, '_blank');
    },
    // 转正
    passTea(val) {
      if (!val.id) return false;
      passteSubscribe(val.id)
        .then(result => {
          this.$message({
            message: this.$t('pc_biz_te_msg_beofficial_success').d('转正成功'),
            type: 'success'
          });
          this.refresh();
          this.getBaseinfo();
        }).catch(e => {
          this.handleError(e);
        });
    },
    // 取消资格
    rejectTea(val) {
      if (!val.id) return false;
      this.$confirm(this.$t('pc_biz_te_subscribe_msgCancel', [this.baseInfo.targetName] /* 当取消资格后，人员会自动从【业务方提供】内移除，请在此确认？*/),
        this.$t('pc_biz_enroll_confirm_cancel' /* 确认要取消资格吗？*/), {
          confirmButtonText: this.$t('pc_comp_drawer_confirm'),
          cancelButtonText: this.$t('pc_comp_drawer_cancel'),
          type: 'warning'
        }).then(() => {
        rejectTeSubscribe(val.id)
          .then(result => {
            this.$message({
              message: this.$t('pc_biz_te_msg_recusal_success').d('取消资格成功'),
              type: 'success'
            });
            this.refresh();
            this.getBaseinfo();
          }).catch(e => {
          });
      }).catch(() => {
      });
    },
    // 添加名额
    addTe() {
      this.selectTeacher.data = [];
      this.selectTeacher.singleMode = false;
      this.selectTeacher.callback = this.selectLecturerCallback;
      this.$nextTick(() => {
        this.selectTeacher.visible = true;
      });
    },
    selectLecturerCallback(users = []) {
      const teIds = users.map(user => user.id);
      addSubscribeTeList(this.targetId, teIds)
        .then(result => {
          this.refresh();
          this.getBaseinfo();
        }).catch(e => {
          this.handleError(e);
        });
    },
    // 获取状态颜色
    getStatusColor(status) {
      switch (status) {
        case 0:
        case 1:
          return 'blue';
        case 2:
        case 3:
          return 'success';
        case 4:
        case 5:
        case 6:
          return 'danger';
        default:
          'success';
      }
    },
    // 获取任务状态
    getTargetStatus(status) {
      switch (status) {
        case 0:
        case 3:
          return this.$t('pc_biz_te_lbl_notopened').d('未开启');
        case 1:
          return this.$t('pc_biz_enroll_lbl_hasOpen').d('已开启');
        case 2:
          return this.$t('pc_biz_ls_over').d('已结束');
        default:
          return '--';
      }
    },
    // 获取加入方式
    getJoinType(type) {
      switch (type) {
        case 0:
          return this.$t('pc_biz_lbl_subscribe_join').d('预约加入');
        case 1:
          return this.$t('pc_biz_lbl_assigned_teaching').d('指派授课');
        default:
          return '--';
      }
    },
    copyUrl() {
      let input = document.createElement('input');
      input.value = this.baseInfo.targetUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand('Copy'); // 执行浏览器复制命令
      this.$message.success(this.$t('pc_biz_enroll_msg_arrangecopied' /* 复制成功 */));
      document.body.removeChild(input);
    },
    handleError(error) {
      if (error && error.error) {
        // 兼容处理
        error = error.error;
      }
      if (error) {
        if (error.key && error.key.indexOf('global.token') >= 0) {
          return; // 不弹出token错误
        }
        // 默认从message里取出来，如果不存在，就从key拿国际化
        const msg = error.message ? error.message : this.$t(error.key);
        this.$message({
          message: msg,
          type: 'error'
        });
      }
    }
  }
};
</script>
